export default __webpack_public_path__ + "static/media/learose4.d5ac4a7e.jpg";